import { Trans } from '@lingui/macro'
import { dateFormat } from 'app/appSettings'
import moment from 'moment'
import * as Yup from 'yup'

Yup.addMethod(Yup.array, 'checkMilestoneUpdateChronologyWithInputValidation', function (message, validStatuses) {
  return this.test('checkMilestoneUpdateChronologyWithInputValidation', message, function (baseMilestones) {
    const milestones = Array.isArray(validStatuses) ? baseMilestones.filter(milestone => validStatuses.length === 0 || validStatuses.includes(milestone.stage)) : baseMilestones
    const { path, createError } = this
    if (milestones.length === 0) {
      return true
    }
    const startDates = milestones.map(item => item.milestoneUpdate?.phaseStartDate)
      .map(item => item?.format ? item.format(dateFormat) : item) // format is a function of moment.js
    const endDates = milestones.map(item => item.milestoneUpdate?.phaseEndDate)
      .map(item => item?.format ? item.format(dateFormat) : item) // format is a function of moment.js
    let bool = false
    const errors = []
    for (let index = 0; index < startDates.length; index++) {
      if (!moment.utc(startDates[index], dateFormat, true).isValid()) {
        bool = true
        errors.push(
          new Yup.ValidationError(
            <Trans>VALID_DATE_FORMAT_ERROR</Trans>,
            startDates[index],
            path + `[${index}].milestoneUpdate.phaseStartDate`
          )
        )
      }
    }
    for (let index = 0; index < endDates.length; index++) {
      if (!moment.utc(endDates[index], dateFormat, true).isValid()) {
        bool = true
        errors.push(
          new Yup.ValidationError(
            <Trans>VALID_DATE_FORMAT_ERROR</Trans>,
            endDates[index],
            path + `[${index}].milestoneUpdate.phaseEndDate`
          )
        )
      }
    }
    if (bool) {
      return createError({ message: () => errors })
    }
    for (let index = 1; index < startDates.length; index++) {
      if (startDates[index] && endDates[index - 1] && startDates[index] <= endDates[index - 1]) {
        bool = true
        errors.push(
          new Yup.ValidationError(
            message,
            startDates[index],
            path + `[${index}].milestoneUpdate.phaseStartDate`
          )
        )
        errors.push(
          new Yup.ValidationError(
            message,
            endDates[index],
            path + `[${index - 1}].milestoneUpdate.phaseEndDate`
          )
        )
        errors.push(new Yup.ValidationError(milestones[index]?.stage, milestones[index]?.stage, path + `[${index}].milestone`))
        errors.push(new Yup.ValidationError(milestones[index]?.id, milestones[index]?.id, path + `[${index}].id`))
        errors.push(new Yup.ValidationError(milestones[index - 1]?.stage, milestones[index - 1]?.stage, path + `[${index - 1}].milestone`))
        errors.push(new Yup.ValidationError(milestones[index - 1]?.id, milestones[index - 1]?.id, path + `[${index - 1}].id`))
      }
    }
    for (let index = 0; index < endDates.length; index++) {
      if (startDates[index] && endDates[index] && endDates[index] <= startDates[index]) {
        bool = true
        errors.push(
          new Yup.ValidationError(
            <Trans />,
            endDates[index],
            path + `[${index}].milestoneUpdate.phaseEndDate`
          )
        )
        errors.push(
          new Yup.ValidationError(
            <Trans />,
            startDates[index],
            path + `[${index}].milestoneUpdate.phaseStartDate`
          )
        )
        errors.push(new Yup.ValidationError(message, 'yes', path + `[${index}].milestoneUpdate.phaseDate`))
        errors.push(new Yup.ValidationError(milestones[index]?.stage, milestones[index]?.stage, path + `[${index}].milestone`))
        errors.push(new Yup.ValidationError(milestones[index]?.id, milestones[index]?.id, path + `[${index}].id`))
      }
    }
    if (bool) {
      return createError({ message: () => errors })
    }
    return !bool
  })
})

Yup.addMethod(Yup.array, 'areDatesChanged', function (message) {
  return this.test('areDatesChanged', message, function (milestones) {
    const { path, createError } = this
    if (milestones.length === 0) {
      return true
    }
    const startDates = milestones.map(item => item.milestoneUpdate?.phaseStartDate)
      .map(item => item?.format ? item.format('YYYY-MM-DD') : item) // format is a function of moment.js
    const endDates = milestones.map(item => item.milestoneUpdate?.phaseEndDate)
      .map(item => item?.format ? item.format('YYYY-MM-DD') : item) // format is a function of moment.js
    const _startDates = milestones.map(item => item.startDate)
      .map(item => item?.format ? item.format('YYYY-MM-DD') : item) // format is a function of moment.js
    const _endDates = milestones.map(item => item.endDate)
      .map(item => item?.format ? item.format('YYYY-MM-DD') : item) // format is a function of moment.js

    let bool = false
    let atLeastOneChanged = false
    const errors = []

    milestones.forEach((item, idx) => {
      const areDatesChangedError = item.milestoneUpdate?.areDatesChanged === 'yes' && startDates[idx] === _startDates[idx] && endDates[idx] === _endDates[idx]
      if (areDatesChangedError) {
        bool = true
        errors.push(new Yup.ValidationError(<Trans />, 'yes', path + `[${idx}].milestoneUpdate.phaseEndDate`))
        errors.push(new Yup.ValidationError(<Trans />, 'yes', path + `[${idx}].milestoneUpdate.phaseStartDate`))
        errors.push(new Yup.ValidationError(message, 'yes', path + `[${idx}].milestoneUpdate.phaseDate`))
        errors.push(new Yup.ValidationError(milestones[idx]?.stage, milestones[idx]?.stage, path + `[${idx}].milestone`))
        errors.push(new Yup.ValidationError(milestones[idx]?.id, milestones[idx]?.id, path + `[${idx}].id`))
      } else {
        atLeastOneChanged = true
      }
    })

    if (bool && !atLeastOneChanged) {
      return createError({ message: () => errors })
    } else {
      return true
    }
  })
})

Yup.addMethod(Yup.array, 'checkRequiredTextFields', function (message, validStatuses = []) {
  return this.test('checkRequiredTextFields', message, function (milestones = []) {
    const { path, createError } = this
    if (milestones.length === 0) {
      return true
    }
    let bool = false
    const errors = []
    milestones
      .filter(milestone => validStatuses?.length === 0 || validStatuses?.includes(milestone.stage))
      .forEach((item, idx) => {
        const isEmptyText = item.milestoneUpdate?.implementedActivities ? item.milestoneUpdate?.implementedActivities.trim() === '' : true
        if (isEmptyText) {
          bool = true
          errors.push(new Yup.ValidationError(message, 'yes', path + `[${idx}].milestoneUpdate.implementedActivities`))
          errors.push(new Yup.ValidationError(milestones[idx]?.stage, milestones[idx]?.stage, path + `[${idx}].milestone`))
          errors.push(new Yup.ValidationError(milestones[idx]?.id, milestones[idx]?.id, path + `[${idx}].id`))
        }
      })
    if (bool) {
      return createError({ message: () => errors })
    }
    return !bool
  })
})

const chronologicalTrans = (
  <Trans>Dates have to be in chronological order!</Trans>
)
const areDatesChangedTrans = (<Trans>FORM_MILESTONES_UPDATE_ARE_DATES_CHANGED_ERRORS</Trans>)
const requiredText = <Trans>Required</Trans>

export const FormMilestoneUpdateValidation = item => {
  const { validStatuses } = item.typeProps
  const baseObject = {}
  return Yup.array()
    .ensure()
    .of(Yup.object(baseObject))
    .areDatesChanged(areDatesChangedTrans)
    .checkMilestoneUpdateChronologyWithInputValidation(chronologicalTrans, validStatuses)
    .checkRequiredTextFields(requiredText, validStatuses)
    // .checkStartDateMinDate({message: startDateMinDateTrans, phases: item.typeProps.phases})
    .label(<Trans>FORM_MILESTONE_UPDATE_VALIDATION</Trans>)
}
